import * as Sentry from '@sentry/react';

/**
 * Sentry پنل ادمین — فقط با REACT_APP_SENTRY_DSN فعال می‌شود
 * (CRA متغیر را در زمان build داخل باندل می‌گذارد؛ بعد از ست‌کردن باید rebuild شود).
 */
const dsn = process.env.REACT_APP_SENTRY_DSN || '';

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      'NetworkError',
      'Failed to fetch',
      'AbortError',
      /extension\//i,
      /^chrome-extension:/i,
    ],
  });
}

export const sentryEnabled = Boolean(dsn);
export { Sentry };
